<tr>
    <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="col.sortDisabled || false" [style.width]="col.width">
        <div [style]="col.style">{{col.header}}
            <p-sortIcon *ngIf="!(col.sortDisabled || false)" [field]="col.field"></p-sortIcon>
        </div>
    </th>
</tr>
